// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"525035a0","72":"50d5cc23","89":"f48869f4","113":"24d0a355","187":"202c575b","243":"7cab7be1","289":"c56cd402","381":"5ba833e1","426":"b989843e","463":"12b9f629","510":"e6e2929c","593":"013c3088","629":"ff1ec673","876":"ece8cf7d"}[chunkId] + ".chunk.js";
};